import { format, parseISO, differenceInCalendarDays, addDays, startOfDay } from 'date-fns';

export function getDateKey(date: Date | string = new Date()): string {
  const resolved = typeof date === 'string' ? parseISO(date) : date;
  return format(resolved, 'yyyy-MM-dd');
}

export function getTodayKey(): string {
  return getDateKey(new Date());
}

/** Returns the last n date keys, oldest first, ending with today. */
export function getLastNDays(n: number): string[] {
  const today = startOfDay(new Date());
  const days: string[] = [];
  for (let i = n - 1; i >= 0; i -= 1) {
    days.push(getDateKey(addDays(today, -i)));
  }
  return days;
}

export function formatWeekdayLetter(dateKey: string): string {
  return format(parseISO(dateKey), 'EEEEE');
}

export function formatFullDate(date: Date = new Date()): string {
  return format(date, 'EEEE, MMMM d');
}

export function isOverdue(dateString: string): boolean {
  return differenceInCalendarDays(startOfDay(parseISO(dateString)), startOfDay(new Date())) < 0;
}

/** Friendly relative label for a deadline, e.g. "Today", "Tomorrow", "3d overdue", "Mar 4". */
export function formatFriendlyDeadline(dateString: string, includeTime = false): string {
  const date = parseISO(dateString);
  const diff = differenceInCalendarDays(startOfDay(date), startOfDay(new Date()));
  const timePart = includeTime ? ` · ${format(date, 'h:mm a')}` : '';

  if (diff === 0) return `Today${timePart}`;
  if (diff === 1) return `Tomorrow${timePart}`;
  if (diff === -1) return `Yesterday${timePart}`;
  if (diff < -1) return `${Math.abs(diff)}d overdue`;
  if (diff > 1 && diff <= 6) return `${format(date, 'EEEE')}${timePart}`;
  return `${format(date, 'MMM d')}${timePart}`;
}
